import { __assign } from "tslib";
import React from "react";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { Check } from "../check";
import { RadioGroup } from "./RadioGroup";
export var Radio = forwardRefWithStatics(function (props, ref) {
    return React.createElement(Check, __assign({ ref: ref, radio: true }, props));
}, 
// statics
{
    Group: RadioGroup,
});
//# sourceMappingURL=Radio.js.map